module.exports = "/assets/data/4df7b9c421e6761244bcac259c280f3e-CM20.data.json";